const columns = [
  { name: 'username', title: 'Benutzername' },
  // RITA-1535: Vorname und Nachname direkt hinter dem Benutzernamen (Platzhalter BEARBEITER der Anschreiben).
  { name: 'first_name', title: 'Vorname' },
  { name: 'last_name', title: 'Nachname' },
  { name: 'email', title: 'Email' },
  { name: 'enabled', title: 'Aktiviert' },
  { name: 'password', title: 'Passwort' },
  { name: 'last_login', title: 'Letzte Anmeldung' },
  { name: 'roles', title: 'Rolle' },
];
export default columns;
